import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonHeaderComponent } from 'pi-ui';

@Component({
    selector: 'app-auth-header',
    templateUrl: './auth-header.component.html',
    styleUrls: ['./auth-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonHeaderComponent]
})
export class AuthHeaderComponent {
}
